<template>
  <div>
    <PublicLayout>
      <header
        class="header"
        :style="{
          backgroundImage: `url(${require('@/assets/public/images/contribution/header.jpg')})`,
        }"
      >
        <div class="container">
          <h1>đóng góp xã hội<!--社会貢献--></h1>
        </div>
      </header>
      <!-- main-section -->
      <section class="main-section">
        <!-- m-sec -->
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title text-primary text-center">
              “Đầu tư cho tương lai” là hoạt động đóng góp xã hội của Futez.
              <!--「對未來的投資」是富地滋的社會貢獻活動。-->
            </h2>
            <p>
              Là một "công ty tạo ra sức khỏe", Fudizhi tổ chức các hội thảo học thuật và các hoạt động khác cho sự tham gia của công chúng, đồng thời cam kết thực hiện các hoạt động đóng góp xã hội.
              <!--富地滋作為「健康創造企業」，在舉辦民眾參與的學術研討會等活動的同時，也致力於社會貢獻活動。-->
              <br />
              Trở thành một doanh nghiệp không chỉ có nghĩa là tạo ra lợi nhuận và đóng thuế mà còn là cải thiện xã hội nơi chúng ta đang sống.
              <!--身為企業不僅是創造利益、納稅，還要致力於改善我們所生活的社會。-->
              <br />
              Đây cũng là một trong những trách nhiệm xã hội quan trọng của doanh nghiệp.
              <!--這也是對企業來說重要的社會責任之一。--> 
              <br />
              Trong số đó, việc cung cấp những vật dụng cần thiết cho những người có nhu cầu là một trong những cách trực tiếp hơn cả.
              <!--其中，對於支援必要物資給予需要的人，是其中一種較為直接的方式。-->
              <br />
              Tuy nhiên, phương pháp này chỉ có thể mang lại giải pháp tạm thời, điều trị triệu chứng chứ không thể điều trị tận gốc nguyên nhân.
              <!--然而，這個方法只能暫時性解決，治標不治本。--> 
              <br />
              Chúng ta nên làm gì vì lợi ích của người dân sống ở đó? Chúng ta có thể làm gì?
              <!--為了在那裡生活的人們，我們應該做什麼？我們能做什麼呢？ -->
              <br />
              Hoạt động của Fudizi là tạo ra một tương lai tốt đẹp hơn. Chúng tôi bắt đầu từ cảm nhận, suy nghĩ và hành động.
              <!--富地滋的活動是為了創造更好的未來，我們從感受、思考、行動開始。-->
            </p>
          </div>
        </section>
        <!-- m-sec end -->
        <!-- m-sec -->
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title text-primary text-center">
              Tạo ra một môi trường nơi mọi người có thể sống
              <!--創造人們可以生活的環境-->
            </h2>
            <p>
              Đây là một khoản đầu tư cho tương lai của chúng tôi. Từ giờ trở đi, Futez sẽ vượt ra ngoài "CSR" (trách nhiệm xã hội của doanh nghiệp), 
              đề cập đến cả hoạt động của công ty và đóng góp cho xã hội, và hướng tới mục tiêu "CSV" (Tạo ra giá trị chung) 
              và nỗ lực giải quyết các vấn đề xã hội và Sức khỏe tạo nên sự nghiệp.
              <!--這是對我們未來的投資。今後富地滋將超越所謂企業活動與社會貢獻兩者稱之的「CSR」(企業的社會責任)，朝「CSV」(Creating Shared Value=創造共享價值)為目標邁進，致力於解決社會課題和健康創造事業。-->
            </p>
          </div>
        </section>
        <!-- m-sec end -->
      </section>
      <!-- main-section -->
    </PublicLayout>
  </div>
</template>

<script>
import PublicLayout from "../../components/public/PublicLayout";
export default {
  name: "ContributionScreen",
  components: {
    PublicLayout,
  },
};
</script>
